var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse2, _path11, _path12, _path13, _path14, _path15, _ellipse3, _path16, _path17, _path18, _path19, _ellipse4, _path20, _path21, _path22, _rect, _path23, _path24, _rect2, _path25, _path26, _rect3, _path27, _path28, _rect4, _path29, _path30, _rect5, _path31, _path32, _rect6, _path33, _path34, _rect7, _path35, _path36, _rect8, _path37, _path38, _rect9, _path39, _path40, _rect10, _path41, _path42, _rect11, _path43, _path44, _rect12, _path45, _path46, _rect13, _path47, _path48, _rect14, _path49, _path50, _rect15, _path51, _path52, _rect16, _path53, _path54, _rect17, _path55, _path56, _rect18, _path57, _path58, _rect19, _path59, _path60, _rect20, _path61, _path62, _rect21, _path63, _path64, _rect22, _path65, _path66, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonster4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 185,
    viewBox: "0 0 189 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.6687,
    cy: 160.216,
    rx: 82.5,
    ry: 21.5,
    fill: "url(#paint0_radial_14011_169618)",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.41 65.3899C178.19 54.8708 166.267 74.9542 140.709 91.3624C114.856 107.957 114.026 107.738 123.756 122.893C139.096 146.783 198.308 80.6193 186.41 65.3899Z",
    fill: "#FF122F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M182.766 69.3384C175.851 60.4906 165.823 77.3843 144.321 91.1853C122.577 105.147 121.877 104.96 130.061 117.706C142.966 137.805 192.775 82.1484 182.766 69.3384Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.401 65.3899C10.6192 54.8708 22.541 74.9542 48.1014 91.3624C73.9548 107.957 74.7835 107.738 65.0526 122.893C49.7133 146.783 -9.49973 80.6193 2.401 65.3899Z",
    fill: "#FF122F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.04276 69.3384C12.9572 60.4906 22.9858 77.3843 44.4879 91.1853C66.2339 105.147 66.9319 104.96 58.7476 117.706C45.8454 137.805 -3.96595 82.1484 6.04276 69.3384Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.712 109.256C156.712 74.7057 128.703 36.146 94.1484 36.146C59.5958 36.146 31.5854 74.7057 31.5854 109.256C31.5854 133.182 45.0176 156.905 64.7537 160.117C73.5182 161.545 83.5234 147.029 94.1484 147.029C105.419 147.029 115.991 161.506 125.126 159.845C128.585 159.215 131.838 157.899 134.844 156.027C148.229 147.678 156.712 128.27 156.712 109.256Z",
    fill: "#FF122F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3433 30.5788C31.6304 31.2102 31.9957 31.8509 32.4042 32.4963C32.4007 32.4987 32.3984 32.4998 32.3937 32.501C42.4562 49.5289 55.6198 62.535 70.1573 62.535C81.0087 62.535 91.2392 55.4496 99.8683 44.71C97.8105 40.729 89.8619 28.9892 81.4546 25.0783C83.8217 27.9563 84.5266 28.8526 85.6145 31.9244C76.3516 26.8569 63.0911 22.7254 49.7441 25.223C59.8894 26.1018 62.2577 28.3415 64.1765 30.0034C58.5775 30.1213 47.4471 24.6033 34.6067 28.4138C36.5922 28.4383 44.724 28.4056 46.9627 30.3652C45.9286 30.7247 34.9032 28.3298 31.3433 30.5788Z",
    fill: "#FF122F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9656 41.5391C33.5796 41.692 34.2134 41.9102 34.8612 42.1693C34.8635 42.1658 34.8635 42.1635 34.8647 42.1611C51.8101 48.3164 65.6718 57.9263 68.11 70.951C69.9309 80.6706 65.2982 91.0263 57.1243 100.557C53.2119 99.3792 41.359 94.2288 36.4439 87.3546C39.4214 88.9932 40.3412 89.4729 43.2767 89.9315C37.1827 82.4843 31.2557 71.2988 31.2545 58.9218C33.7442 67.8641 36.1474 69.6089 37.9601 71.0502C37.1244 66.0154 30.3138 56.9692 31.5743 44.8268C31.9292 46.6019 33.2633 53.8916 35.3957 55.5687C35.5428 54.5814 31.5475 45.1057 32.9656 41.5391Z",
    fill: "#FF122F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M156.957 30.5788C156.668 31.2102 156.302 31.8509 155.895 32.4963C155.897 32.4987 155.902 32.4998 155.905 32.501C145.844 49.5289 132.68 62.535 118.143 62.535C107.291 62.535 97.0597 55.4496 88.4294 44.71C90.4895 40.729 98.4382 28.9892 106.844 25.0783C104.476 27.9563 103.773 28.8526 102.686 31.9244C111.948 26.8569 125.209 22.7254 138.556 25.223C128.411 26.1018 126.042 28.3415 124.122 30.0034C129.72 30.1213 140.852 24.6033 153.693 28.4138C151.708 28.4383 143.575 28.4056 141.337 30.3652C142.371 30.7247 153.396 28.3298 156.957 30.5788Z",
    fill: "#FF122F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155.333 41.5391C154.72 41.692 154.085 41.9102 153.44 42.1693C153.438 42.1658 153.438 42.1635 153.435 42.1611C136.49 48.3164 122.629 57.9263 120.191 70.951C118.369 80.6706 123.002 91.0263 131.177 100.557C135.088 99.3792 146.942 94.2288 151.856 87.3546C148.878 88.9932 147.96 89.4729 145.022 89.9315C151.118 82.4843 157.043 71.2988 157.045 58.9218C154.557 67.8641 152.152 69.6089 150.341 71.0502C151.174 66.0154 157.987 56.9692 156.727 44.8268C156.372 46.6019 155.038 53.8916 152.905 55.5687C152.755 54.5814 156.752 45.1057 155.333 41.5391Z",
    fill: "#FF122F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.238 75.6757C141.58 70.9559 143.223 65.4881 143.223 59.69C141.253 66.7684 139.35 68.1491 137.915 69.2893C138.576 65.3049 143.969 58.1447 142.97 48.536C142.688 49.94 141.632 55.709 139.945 57.0372C139.829 56.2552 142.992 48.7554 141.87 45.9322C141.382 46.0536 140.879 46.2275 140.367 46.4318V46.4247C138.842 46.978 137.351 47.5662 135.9 48.1894C138.181 45.3277 140.327 42.1532 142.321 38.7791C142.316 38.7779 142.316 38.7768 142.313 38.7756C142.637 38.2644 142.925 37.7579 143.153 37.2584C140.334 35.4774 131.608 37.3728 130.79 37.0891C132.561 35.5369 138.999 35.5638 140.57 35.5462C130.407 32.5281 121.597 36.8966 117.166 36.8032C118.686 35.4867 120.558 33.7139 128.59 33.0195C118.026 31.0424 107.529 34.3126 100.198 38.3228C101.061 35.8929 101.617 35.1833 103.492 32.9039C99.7776 34.6312 96.1838 38.2831 93.4443 41.7249C90.7038 38.2831 87.1065 34.6312 83.3948 32.9039C85.2681 35.1833 85.826 35.8929 86.6874 38.3228C79.3563 34.3126 68.8608 31.0424 58.2942 33.0195C66.3268 33.7139 68.2002 35.4867 69.7211 36.8032C65.2892 36.8966 56.478 32.5281 46.3164 35.5462C47.8875 35.5638 54.3234 35.5369 56.0964 37.0891C55.2758 37.3728 46.5498 35.4774 43.7334 37.2584C43.9598 37.7579 44.2493 38.2644 44.5738 38.7756C44.5714 38.7768 44.5691 38.7779 44.5656 38.7791C46.5592 42.1532 48.7057 45.3277 50.9852 48.1894C49.5344 47.5662 48.0427 46.978 46.5195 46.4247C46.5183 46.4259 46.5183 46.4283 46.5183 46.4318C46.0048 46.2275 45.5029 46.0536 45.0173 45.9322C43.8945 48.7554 47.0564 56.2552 46.9409 57.0372C45.2531 55.709 44.1968 49.94 43.9143 48.536C42.9187 58.1447 48.31 65.3049 48.9694 69.2893C47.5361 68.1491 45.6336 66.7684 43.6622 59.69C43.6622 66.0378 45.6336 71.9888 48.3322 76.9957C42.1729 88.3959 38.5674 101.445 38.5674 113.86C38.5674 146.473 63.452 144.649 94.1493 144.649C124.848 144.649 149.732 146.473 149.732 113.86C149.732 100.963 145.84 87.3828 139.238 75.6757Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.9,
    cx: 95.2081,
    cy: 101.728,
    rx: 57.6437,
    ry: 35.7079,
    fill: "url(#paint1_radial_14011_169618)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M145.041 112.42C145.041 118.214 140.344 122.911 134.549 122.911H54.7071C48.912 122.911 44.2152 118.214 44.2152 112.42C44.2152 106.627 48.912 101.929 54.7071 101.929H134.549C140.344 101.929 145.041 106.627 145.041 112.42Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1761 74.6858C90.1761 84.4987 82.2229 92.4548 72.4091 92.4548C62.5941 92.4548 54.6397 84.4987 54.6397 74.6858C54.6397 64.8717 62.5941 56.9168 72.4091 56.9168C82.2229 56.9168 90.1761 64.8717 90.1761 74.6858Z",
    fill: "#DA4854"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.0285 74.6845C89.0285 83.8622 81.5878 91.3023 72.4092 91.3023C63.2306 91.3023 55.7899 83.8622 55.7899 74.6845C55.7899 65.5067 63.2306 58.0667 72.4092 58.0667C81.5878 58.0667 89.0285 65.5067 89.0285 74.6845Z",
    fill: "url(#paint2_radial_14011_169618)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.3511 74.6856C81.3511 79.6229 77.3483 83.6253 72.4106 83.6253C67.4729 83.6253 63.4701 79.6229 63.4701 74.6856C63.4701 69.7483 67.4729 65.7458 72.4106 65.7458C77.3483 65.7458 81.3511 69.7483 81.3511 74.6856Z",
    fill: "url(#paint3_radial_14011_169618)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5909 74.6855C76.5909 76.9952 74.7188 78.8672 72.41 78.8672C70.099 78.8672 68.2268 76.9952 68.2268 74.6855C68.2268 72.3758 70.099 70.5038 72.41 70.5038C74.7188 70.5038 76.5909 72.3758 76.5909 74.6855Z",
    fill: "#2E2A49"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.4178,
    cy: 70.2702,
    rx: 4.97746,
    ry: 3.82514,
    fill: "url(#paint4_radial_14011_169618)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M133.659 74.6851C133.659 84.4992 125.706 92.4553 115.889 92.4553C106.075 92.4553 98.1205 84.4992 98.1205 74.6851C98.1205 64.871 106.075 56.9161 115.889 56.9161C125.706 56.9161 133.659 64.871 133.659 74.6851Z",
    fill: "#DA4854"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.509 74.6849C132.509 83.863 125.069 91.3032 115.89 91.3032C106.711 91.3032 99.2701 83.863 99.2701 74.6849C99.2701 65.5069 106.711 58.0667 115.89 58.0667C125.069 58.0667 132.509 65.5069 132.509 74.6849Z",
    fill: "url(#paint5_radial_14011_169618)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.831 74.6844C124.831 79.6216 120.829 83.6241 115.891 83.6241C110.953 83.6241 106.95 79.6216 106.95 74.6844C106.95 69.7471 110.953 65.7446 115.891 65.7446C120.829 65.7446 124.831 69.7471 124.831 74.6844Z",
    fill: "url(#paint6_radial_14011_169618)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120.07 74.6848C120.07 76.9957 118.198 78.8677 115.889 78.8677C113.579 78.8677 111.708 76.9957 111.708 74.6848C111.708 72.3751 113.579 70.5031 115.889 70.5031C118.198 70.5031 120.07 72.3751 120.07 74.6848Z",
    fill: "#2E2A49"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.892,
    cy: 70.27,
    rx: 4.97745,
    ry: 3.82514,
    fill: "url(#paint7_radial_14011_169618)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6993 101.443C48.9177 101.443 44.2228 106.159 44.2228 111.94C44.2228 117.743 48.9177 122.438 54.6993 122.438H134.555C140.337 122.438 145.032 117.743 145.032 111.94C145.032 106.159 140.337 101.443 134.555 101.443H54.6993Z",
    fill: "url(#paint8_linear_14011_169618)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9921 101.454V103.202C53.9921 104.784 55.2748 106.069 56.8564 106.069C58.4403 106.069 59.7219 104.784 59.7219 103.202V101.454H53.9921Z",
    fill: "#EDDD9A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4404 101.454V102.93C54.4404 104.262 55.5224 105.344 56.8565 105.344C58.1918 105.344 59.2738 104.262 59.2738 102.93V101.454H54.4404Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.72979,
    height: 1.68645,
    transform: "matrix(-1 0 0 1 59.719 101.453)",
    fill: "#E66D28"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5198 101.454C61.5198 101.458 61.5187 101.465 61.5187 101.469V103.202C61.5187 104.784 62.8026 106.069 64.3841 106.069C65.9657 106.069 67.2496 104.784 67.2496 103.202V101.469C67.2496 101.465 67.2484 101.458 67.2484 101.454H61.5198Z",
    fill: "#EDDD9A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9688 101.454V102.93C61.9688 104.262 63.0496 105.344 64.3836 105.344C65.7177 105.344 66.8009 104.262 66.8009 102.93V101.454H61.9688Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.72971,
    height: 1.68645,
    transform: "matrix(-1 0 0 1 67.2499 101.453)",
    fill: "#E66D28"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0453 101.454V103.202C69.0453 104.784 70.328 106.069 71.9119 106.069C73.4935 106.069 74.7763 104.784 74.7763 103.202V101.454H69.0453Z",
    fill: "#EDDD9A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4971 101.454C69.496 101.458 69.496 101.463 69.496 101.467V102.93C69.496 104.262 70.578 105.344 71.9121 105.344C73.2462 105.344 74.3282 104.262 74.3282 102.93V101.467C74.3282 101.463 74.327 101.458 74.327 101.454H69.4971Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5.73098,
    height: 1.68529,
    transform: "matrix(1 0 0 -1 69.0453 103.139)",
    fill: "#E66D28"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5731 101.454V103.202C76.5731 104.784 77.8559 106.069 79.4397 106.069C81.0213 106.069 82.304 104.784 82.304 103.202V101.454H76.5731Z",
    fill: "#EDDD9A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M77.022 101.454V102.93C77.022 104.262 78.104 105.344 79.4393 105.344C80.7734 105.344 81.8554 104.262 81.8554 102.93V101.454H77.022Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5.7309,
    height: 1.68529,
    transform: "matrix(1 0 0 -1 76.5731 103.139)",
    fill: "#E66D28"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1008 101.454V103.202C84.1008 104.784 85.3836 106.069 86.9651 106.069C88.549 106.069 89.8306 104.784 89.8306 103.202V101.454H84.1008Z",
    fill: "#EDDD9A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5498 101.454V102.93C84.5498 104.262 85.6318 105.344 86.9659 105.344C88.3011 105.344 89.3831 104.262 89.3831 102.93V101.454H84.5498Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 5.72979,
    height: 1.68529,
    transform: "matrix(1 0 0 -1 84.1014 103.139)",
    fill: "#E66D28"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6287 101.454C91.6287 101.458 91.6263 101.465 91.6263 101.469V103.202C91.6263 104.784 92.9114 106.069 94.4918 106.069C96.0769 106.069 97.3584 104.784 97.3584 103.202V101.454H91.6287Z",
    fill: "#EDDD9A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0781 101.454C92.0781 101.458 92.0758 101.463 92.0758 101.467V102.93C92.0758 104.262 93.159 105.344 94.4919 105.344C95.8283 105.344 96.9103 104.262 96.9103 102.93V101.454H92.0781Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 5.72978,
    height: 1.68645,
    transform: "matrix(-1 0 0 1 97.3556 101.453)",
    fill: "#E66D28"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1547 101.454V103.202C99.1547 104.784 100.437 106.069 102.021 106.069C103.603 106.069 104.887 104.784 104.887 103.202V101.469C104.887 101.465 104.884 101.458 104.884 101.454H99.1547Z",
    fill: "#EDDD9A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6054 101.454C99.603 101.458 99.603 101.463 99.603 101.467V102.93C99.603 104.262 100.685 105.344 102.02 105.344C103.354 105.344 104.436 104.262 104.436 102.93V101.454H99.6054Z",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 5.73202,
    height: 1.68529,
    transform: "matrix(1 0 0 -1 99.1547 103.139)",
    fill: "#E66D28"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M106.682 101.454V103.202C106.682 104.784 107.965 106.069 109.546 106.069C111.13 106.069 112.412 104.784 112.412 103.202V101.454H106.682Z",
    fill: "#EDDD9A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M107.131 101.454V102.93C107.131 104.262 108.213 105.344 109.546 105.344C110.883 105.344 111.965 104.262 111.965 102.93V101.454H107.131Z",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 5.72971,
    height: 1.68645,
    transform: "matrix(-1 0 0 1 112.406 101.453)",
    fill: "#E66D28"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M114.209 101.454V103.202C114.209 104.784 115.492 106.069 117.073 106.069C118.658 106.069 119.94 104.784 119.94 103.202V101.454H114.209Z",
    fill: "#EDDD9A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M114.659 101.454V102.93C114.659 104.262 115.741 105.344 117.073 105.344C118.41 105.344 119.492 104.262 119.492 102.93V101.454H114.659Z",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 5.72979,
    height: 1.68529,
    transform: "matrix(1 0 0 -1 114.21 103.139)",
    fill: "#E66D28"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M121.738 101.454V103.202C121.738 104.784 123.02 106.069 124.601 106.069C126.183 106.069 127.467 104.784 127.467 103.202V101.469C127.467 101.465 127.465 101.458 127.465 101.454H121.738Z",
    fill: "#EDDD9A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M122.186 101.454V102.93C122.186 104.262 123.268 105.344 124.601 105.344C125.935 105.344 127.02 104.262 127.02 102.93V101.467C127.02 101.463 127.017 101.458 127.017 101.454H122.186Z",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 5.72978,
    height: 1.68645,
    transform: "matrix(-1 0 0 1 127.463 101.453)",
    fill: "#E66D28"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M129.266 101.454C129.266 101.458 129.264 101.465 129.264 101.469V103.202C129.264 104.784 130.549 106.069 132.13 106.069C133.712 106.069 134.993 104.784 134.993 103.202V101.454H129.266Z",
    fill: "#EDDD9A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M129.714 101.454V102.93C129.714 104.262 130.795 105.344 132.129 105.344C133.463 105.344 134.544 104.262 134.544 102.93V101.454H129.714Z",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 5.7274,
    height: 1.68645,
    transform: "matrix(-1 0 0 1 134.992 101.453)",
    fill: "#E66D28"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1278 122.434V120.688C54.1278 119.104 55.4106 117.822 56.9922 117.822C58.5761 117.822 59.8577 119.104 59.8577 120.688V122.434H54.1278Z",
    fill: "#EDDD9A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5743 122.434V120.961C54.5743 119.626 55.6563 118.544 56.9904 118.544C58.3257 118.544 59.4077 119.626 59.4077 120.961V122.434H54.5743Z",
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 5.72979,
    height: 1.68646,
    transform: "matrix(-1 0 0 1 59.8547 120.748)",
    fill: "#E66D28"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6544 122.434C61.6544 122.431 61.6532 122.426 61.6532 122.421V120.688C61.6532 119.104 62.9371 117.822 64.5187 117.822C66.1014 117.822 67.3842 119.104 67.3842 120.688V122.434H61.6544Z",
    fill: "#EDDD9A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1045 122.434V120.961C62.1045 119.626 63.1853 118.544 64.5194 118.544C65.8546 118.544 66.9366 119.626 66.9366 120.961V122.423C66.9366 122.426 66.9343 122.43 66.9343 122.434H62.1045Z",
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 5.72979,
    height: 1.68645,
    transform: "matrix(1 0 0 -1 61.6556 122.434)",
    fill: "#E66D28"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M69.181 122.434C69.181 122.431 69.1798 122.426 69.1798 122.421V120.688C69.1798 119.104 70.4637 117.822 72.0464 117.822C73.628 117.822 74.9119 119.104 74.9119 120.688V122.421C74.9119 122.426 74.9107 122.431 74.9107 122.434H69.181Z",
    fill: "#EDDD9A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6311 122.434C69.6299 122.43 69.6299 122.426 69.6299 122.423V120.961C69.6299 119.626 70.713 118.544 72.046 118.544C73.3801 118.544 74.4633 119.626 74.4633 120.961V122.423C74.4633 122.426 74.4621 122.43 74.4621 122.434H69.6311Z",
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 5.7309,
    height: 1.68646,
    transform: "matrix(-1 0 0 1 74.9146 120.748)",
    fill: "#E66D28"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M76.707 122.434V120.688C76.707 119.104 77.9921 117.822 79.5737 117.822C81.1564 117.822 82.438 119.104 82.438 120.688V122.434H76.707Z",
    fill: "#EDDD9A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1571 122.434C77.1559 122.43 77.1559 122.426 77.1559 122.423V120.961C77.1559 119.626 78.239 118.544 79.5731 118.544C80.9072 118.544 81.9892 119.626 81.9892 120.961V122.434H77.1571Z",
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 5.72971,
    height: 1.68645,
    transform: "matrix(1 0 0 -1 76.7089 122.434)",
    fill: "#E66D28"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2355 122.434V120.688C84.2355 119.104 85.5182 117.822 87.0998 117.822C88.6837 117.822 89.9653 119.104 89.9653 120.688V122.434H84.2355Z",
    fill: "#EDDD9A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6837 122.434V120.961C84.6837 119.626 85.7657 118.544 87.0998 118.544C88.4351 118.544 89.5171 119.626 89.5171 120.961V122.434H84.6837Z",
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 5.72978,
    height: 1.68646,
    transform: "matrix(-1 0 0 1 89.9725 120.748)",
    fill: "#E66D28"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7644 122.434V120.688C91.7644 119.104 93.0472 117.822 94.6275 117.822C96.2103 117.822 97.4942 119.104 97.4942 120.688V122.434H91.7644Z",
    fill: "#EDDD9A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2122 122.434V120.961C92.2122 119.626 93.2941 118.544 94.6259 118.544C95.9611 118.544 97.0443 119.626 97.0443 120.961V122.423C97.0443 122.426 97.0419 122.43 97.0419 122.434H92.2122Z",
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 5.72971,
    height: 1.68646,
    transform: "matrix(-1 0 0 1 97.4902 120.748)",
    fill: "#E66D28"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M99.291 122.434C99.291 122.431 99.2887 122.426 99.2887 122.421V120.688C99.2887 119.104 100.574 117.822 102.155 117.822C103.737 117.822 105.019 119.104 105.019 120.688V122.434H99.291Z",
    fill: "#EDDD9A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7405 122.434C99.7405 122.43 99.7382 122.426 99.7382 122.423V120.961C99.7382 119.626 100.822 118.544 102.155 118.544C103.489 118.544 104.571 119.626 104.571 120.961V122.434H99.7405Z",
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 5.7274,
    height: 1.68646,
    transform: "matrix(-1 0 0 1 105.019 120.748)",
    fill: "#E66D28"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M106.816 122.434V120.688C106.816 119.104 108.099 117.822 109.682 117.822C111.265 117.822 112.547 119.104 112.547 120.688V122.434H106.816Z",
    fill: "#EDDD9A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M107.268 122.434C107.268 122.43 107.265 122.426 107.265 122.423V120.961C107.265 119.626 108.35 118.544 109.683 118.544C111.017 118.544 112.099 119.626 112.099 120.961V122.434H107.268Z",
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 5.72978,
    height: 1.68645,
    transform: "matrix(1 0 0 -1 106.818 122.434)",
    fill: "#E66D28"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M114.345 122.434V120.688C114.345 119.104 115.628 117.822 117.21 117.822C118.793 117.822 120.075 119.104 120.075 120.688V122.434H114.345Z",
    fill: "#EDDD9A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M114.792 122.434V120.961C114.792 119.626 115.874 118.544 117.21 118.544C118.544 118.544 119.626 119.626 119.626 120.961V122.434H114.792Z",
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 5.72986,
    height: 1.68646,
    transform: "matrix(-1 0 0 1 120.079 120.748)",
    fill: "#E66D28"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M121.873 122.434C121.873 122.431 121.871 122.426 121.871 122.421V120.688C121.871 119.104 123.156 117.822 124.738 117.822C126.321 117.822 127.603 119.104 127.603 120.688V122.434H121.873Z",
    fill: "#EDDD9A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M122.32 122.434V120.961C122.32 119.626 123.402 118.544 124.736 118.544C126.072 118.544 127.154 119.626 127.154 120.961V122.434H122.32Z",
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 5.72971,
    height: 1.68646,
    transform: "matrix(-1 0 0 1 127.597 120.748)",
    fill: "#E66D28"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M129.398 122.434V120.688C129.398 119.104 130.681 117.822 132.265 117.822C133.846 117.822 135.13 119.104 135.13 120.688V122.434H129.398Z",
    fill: "#EDDD9A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M129.85 122.434C129.848 122.43 129.848 122.426 129.848 122.423V120.961C129.848 119.626 130.931 118.544 132.265 118.544C133.599 118.544 134.682 119.626 134.682 120.961V122.423C134.682 122.426 134.68 122.43 134.68 122.434H129.85Z",
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 5.73209,
    height: 1.68645,
    transform: "matrix(1 0 0 -1 129.397 122.434)",
    fill: "#E66D28"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M108.932 48.1032C108.855 50.2029 110.514 51.862 112.64 52.0693C114.299 52.2508 117.306 51.3176 120.858 50.3844C125.239 49.2438 130.45 48.1032 134.857 49.0364C122.932 43.9816 115.025 44.4741 112.899 44.3964C112.873 44.3964 112.821 44.3964 112.769 44.3964C110.721 44.3964 109.01 46.0295 108.932 48.1032Z",
    fill: "url(#paint9_linear_14011_169618)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3878 44.3965C73.262 44.4742 65.355 43.9817 53.4298 49.0365C57.837 48.1033 63.0478 49.2439 67.429 50.3844C70.9806 51.3176 73.9878 52.2508 75.647 52.0694C77.7728 51.862 79.432 50.203 79.3542 48.1033C79.2764 46.0295 77.5654 44.3965 75.5174 44.3965C75.4655 44.3965 75.4137 44.3965 75.3878 44.3965Z",
    fill: "url(#paint10_linear_14011_169618)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_14011_169618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.6687 160.216) rotate(90) scale(21.5 82.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_14011_169618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.2081 101.728) rotate(90) scale(35.6385 57.6437)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40414,
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681066,
    stopColor: "#EC8F3A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC8F3A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_14011_169618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.4083 74.6853) scale(16.6193 16.6178)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_14011_169618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.4103 74.686) scale(8.94052 8.93974)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#73B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_14011_169618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.4178 78.3239) rotate(-90) scale(11.8789 15.4573)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#2E2A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#2E2A49",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#B0C5FB",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_14011_169618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.89 74.6851) scale(16.6197 16.6183)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_14011_169618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.89 74.6857) scale(8.94052 8.93974)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#73B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_14011_169618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.892 78.3237) rotate(-90) scale(11.8789 15.4573)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#2E2A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#2E2A49",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#B0C5FB",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14011_169618",
    x1: 44.2235,
    y1: 123.068,
    x2: 44.2235,
    y2: 101.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14011_169618",
    x1: 108.932,
    y1: 35.2847,
    x2: 134.857,
    y2: 35.2847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14011_169618",
    x1: 79.3542,
    y1: 35.2848,
    x2: 53.4298,
    y2: 35.2848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonster4);
export default __webpack_public_path__ + "static/media/Monster4.1824a8da66bc5da1d77a956722365964.svg";
export { ForwardRef as ReactComponent };